const OrganizationRouter = {
  path: '/account',
  name: 'Organization',
  component: () => import('@/views/organization/index'),
  children: [
    {
      path: 'index/:accountId',
      name: 'OrgIndex',
      component: () => import('@/views/organization/home'),
      meta: {
        title: '机构名称'
      }
    },
    {
      path: 'index2/:accountId',
      name: 'OrgIndex2',
      component: () => import('@/views/organization/home2'),
      meta: {
        title: '机构名称'
      }
    },
    {
      path: 'news-list/:accountId',
      name: 'OrgNewsList',
      component: () => import('@/views/organization/news-list'),
      meta: { title: '资讯列表' }
    },
    {
      path: 'news-detail/:newsId',
      name: 'OrgNewsDetail',
      component: () => import('@/views/organization/news-detail'),
      meta: { title: '资讯详情' }
    },
    {
      path: 'entry-list/:accountId',
      name: 'OrgEntryList',
      component: () => import('@/views/organization/entry-list'),
      meta: { title: '赛事报名' }
    },
    {
      path: 'about-us/:accountId',
      name: 'OrgAboutUs',
      component: () => import('@/views/organization/about-us'),
      meta: { title: '机构介绍页' }
    },
    {
      path: 'my-entry-list/:accountId',
      name: 'OrgMyEntryList',
      component: () => import('@/views/organization/my-entry-list'),
      meta: { title: '我的参赛' },
    },
    {
      path: 'ads-iframe',
      name: 'OrgAdsIframe',
      component: () => import('@/views/organization/ads-iframe'),
      meta: { title: '帮赛事' },
    }
  ]
}

export default OrganizationRouter
